export default {
  nav: {
    solutions: 'الحلول',
    cases: 'دراسات الحالة',
    kol: 'شراكة KOL',
    contact: 'اتصل بنا',
    login: 'تسجيل دخول الشركات'
  },
  hero: {
    badge: 'اتصالات فورية مدعومة بالذكاء الاصطناعي',
    title: 'اتصالات فورية مثالية لشركات الألعاب العالمية',
    subtitle: 'تكامل عميق لخوارزميات الذكاء الاصطناعي و WebRTC، يوفر حلول صوت وفيديو فائقة الوضوح ومنخفضة الكمون لمطوري الألعاب، يدعم التفاعل عبر المنصات، الترجمة الصوتية الفورية، والتحسين الذكي للفيديو',
    cta: 'ابدأ تجربة مجانية',
    learn: 'اعرف المزيد',
    latency: 'كمون منخفض للغاية',
    nodes: 'عقد عالمية',
    uptime: 'وقت التشغيل'
  },
  features: {
    title: 'المزايا التقنية الأساسية',
    subtitle: 'تكامل عميق للذكاء الاصطناعي و WebRTC لتجربة اتصال ألعاب مثالية',
    ai: {
      title: 'تحسين ذكي بالذكاء الاصطناعي',
      desc: 'تقليل الضوضاء الذكي، إلغاء الصدى، وتحسين الفيديو للحصول على اتصال واضح تمامًا'
    },
    translate: {
      title: 'ترجمة فورية',
      desc: 'دعم الترجمة الفورية متعددة اللغات، كسر حواجز اللغة وربط اللاعبين العالميين'
    },
    global: {
      title: 'تغطية عقد عالمية',
      desc: '200+ عقدة عالمية مع توجيه ذكي لأقل كمون وأفضل جودة اتصال'
    },
    security: {
      title: 'أمان على مستوى المؤسسات',
      desc: 'تشفير من طرف إلى طرف، بيانات آمنة وموثوقة، متوافقة مع معايير الخصوصية الدولية'
    }
  },
  solutions: {
    title: 'الحلول',
    subtitle: 'حلول اتصال صوتي ومرئي احترافية لسيناريوهات الألعاب المختلفة',
    streaming: {
      title: 'حل البث المباشر للألعاب',
      desc: 'توفير تقنية بث فائقة الوضوح ومنخفضة الكمون لمذيعي الألعاب، يدعم ملايين المشاهدين المتزامنين مع تفاعل فوري بدون تأخير. فلاتر الجمال المدعومة بالذكاء الاصطناعي والتأثيرات تجعل البث أكثر جاذبية.',
      f1: 'بث 4K فائق الوضوح بكمون 25 مللي ثانية',
      f2: 'فلاتر جمال بالذكاء الاصطناعي وتأثيرات فورية',
      f3: 'دعم ملايين المشاهدين المتزامنين'
    },
    voice: {
      title: 'حل الصوت الجماعي',
      desc: 'اتصال صوتي جماعي احترافي للألعاب التنافسية مثل MOBA و Battle Royale، يدعم تحديد الموقع الصوتي المكاني لتحديد موقع زملاء الفريق بدقة. تقليل الضوضاء بالذكاء الاصطناعي يضمن اتصالاً واضحًا.',
      f1: 'صوت مكاني ثلاثي الأبعاد لتحديد موقع دقيق',
      f2: 'تقليل الضوضاء بالذكاء الاصطناعي يزيل الضوضاء الخلفية',
      f3: 'دعم 100 مستخدم صوتي متزامن'
    },
    social: {
      title: 'حل التفاعل الاجتماعي',
      desc: 'مكالمات فيديو متعددة الأشخاص، هدايا افتراضية، وتفاعل فوري للألعاب الاجتماعية. دعم الترجمة الصوتية الفورية للتواصل السلس بين اللاعبين من دول مختلفة.',
      f1: 'مكالمات فيديو متعددة الأشخاص، حتى 16 مستخدمًا',
      f2: 'ترجمة فورية، 50+ لغة',
      f3: 'هدايا افتراضية وتأثيرات تفاعلية'
    },
    acceleration: {
      title: 'حل تسريع الألعاب',
      desc: 'بناءً على العقد الموزعة عالميًا وخوارزميات التوجيه الذكية، توفير خدمات تسريع الشبكة للألعاب، تقليل الكمون وفقدان الحزم بشكل فعال. دعم تحسينات بروتوكول الألعاب المتعددة لضمان تجربة لعب سلسة.',
      f1: 'توجيه ذكي، تقليل الكمون بنسبة 60%+',
      f2: 'تحسين متعدد البروتوكولات، تسريع UDP/TCP',
      f3: '200+ عقدة عالمية، وصول أقرب'
    }
  },
  cases: {
    title: 'قصص النجاح',
    subtitle: 'توفير خدمات اتصال صوتي ومرئي احترافية لمئات شركات الألعاب في جميع أنحاء العالم',
    moba: {
      title: 'لعبة MOBA التنافسية',
      desc: 'توفير خدمات بث البطولات العالمية والصوت الجماعي للعبة MOBA الشهيرة، يدعم 500 ألف+ مستخدم متزامن بكمون 18 مللي ثانية، مما يضمن أحداث رياضات إلكترونية سلسة.',
      s1: 'المستخدمون المتزامنون',
      s2: 'متوسط الكمون',
      s3: 'وقت التشغيل'
    },
    battle: {
      title: 'لعبة Battle Royale',
      desc: 'توفير اتصال صوتي لغرف 100 لاعب لألعاب battle royale، الصوت المكاني ثلاثي الأبعاد يساعد اللاعبين على تحديد موقع الأعداء بدقة، تقليل الضوضاء بالذكاء الاصطناعي يضمن اتصالاً واضحًا، مما يعزز تجربة الألعاب التنافسية.',
      s1: 'سعة الغرفة',
      s2: 'كمون الصوت',
      s3: 'رضا المستخدم'
    },
    casual: {
      title: 'لعبة اجتماعية عادية',
      desc: 'توفير مكالمات فيديو وخدمات بث لمنصات الألعاب الاجتماعية، مع أكثر من مليون مستخدم نشط يوميًا، يدعم الترجمة الصوتية الفورية، يربط اللاعبين العالميين لتجربة اجتماعية دولية.',
      s1: 'المستخدمون النشطون يوميًا',
      s2: 'البث اليومي',
      s3: 'معدل الاحتفاظ'
    }
  },
  kol: {
    title: 'برنامج شراكة KOL',
    subtitle: 'ندعو مذيعي الألعاب ومنشئي المحتوى للانضمام إلى برنامج شراكة CM-Tong',
    b1: {
      title: 'دعم مخصص',
      desc: 'فريق دعم تقني مخصص مع وصول ذي أولوية إلى أحدث الميزات'
    },
    b2: {
      title: 'مشاركة الإيرادات',
      desc: 'مشاركة إيرادات الشراكة، الاستفادة من نمو المنصة'
    },
    b3: {
      title: 'التعرض للعلامة التجارية',
      desc: 'الترويج عبر القنوات الرسمية لتعزيز تأثير العلامة التجارية الشخصية'
    },
    b4: {
      title: 'مزايا ذات أولوية',
      desc: 'المشاركة ذات الأولوية في أحداث المنصة لمزيد من التعرض'
    },
    cta: 'التقدم للشراكة'
  },
  contact: {
    title: 'اتصل بنا',
    subtitle: 'املأ متطلباتك وسنتصل بك خلال 24 ساعة',
    name: 'الاسم',
    email: 'البريد الإلكتروني',
    company: 'اسم الشركة',
    message: 'الرسالة',
    submit: 'إرسال',
    submitting: 'جارٍ الإرسال...',
    success: 'تم الإرسال بنجاح! سنتصل بك قريبًا'
  },
  login: {
    title: 'تسجيل دخول الشركات',
    subtitle: 'سجل الدخول إلى حساب شركتك لبدء استخدام منصة CM-Tong',
    email: 'البريد الإلكتروني للشركة',
    emailPlaceholder: 'أدخل البريد الإلكتروني للشركة',
    password: 'كلمة المرور',
    passwordPlaceholder: 'أدخل كلمة المرور',
    remember: 'تذكرني',
    forgot: 'نسيت كلمة المرور؟',
    submit: 'تسجيل الدخول',
    noAccount: 'ليس لديك حساب؟',
    signup: 'سجل الآن',
    back: 'العودة إلى الصفحة الرئيسية'
  },
  footer: {
    desc: 'CM-Tong هي منصة صوت وفيديو احترافية AI+WebRTC، توفر حلول اتصال فوري فعالة ومنخفضة الكمون لشركات الألعاب العالمية.',
    product: 'المنتج',
    company: 'الشركة',
    rights: 'جميع الحقوق محفوظة'
  }
};
